import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-select";

const AddCookwareSubcategory = ({ show, onClose, refresh }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [selDept, setSelDept] = useState(null);
    const [subDeptName, setSubDeptName] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});

    const [deptOpt, setDeptOpt] = useState([]);
    useEffect(() => {
        const fetchLeadTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/cookware_category/get_active`);
                const formatted = response.data.map(item => ({
                    value: item.sno,
                    label: item.category_name,
                }));
                setDeptOpt(formatted);
            } catch (error) {
                console.log('Error fetching data:', error);
            }
        };

        fetchLeadTypes();
    }, []);

    const [data_name, setData] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/cookware_sub_category/getall`)
            .then(response => {
                setData(response.data.map(mode => mode.subcategory_name.toLowerCase()));
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
            });
    }, []);

    const validate = () => {
        const newErrors = {};
        const regex = /^[A-Za-z\s]+$/;

        if (!subDeptName.trim()) {
            newErrors.name = "This Field is Required.";
        } else if (!regex.test(subDeptName)) {
            newErrors.name = "Not a Valid Name";
        } else if (data_name.includes(subDeptName.trim().toLowerCase())) {
            newErrors.name = "This Name Already Exists";
        }

        if (!selDept) {
            newErrors.dept = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = {
            category_id: selDept,
            subcategory_name: subDeptName,
            description: description
        };

        axios.post(`${baseURL}/cookware_sub_category`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Sub Category Created Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Sub Category Creation Failed");
            });
    };

    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Cookware Subcategory</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Cookware Category<span className="required">*</span></label>
                            <Select placeholder="Select Cookware Category" options={deptOpt} onChange={(e) => setSelDept(e.value)}  />
                            {errors.dept && (<div className="text-danger">{errors.dept}</div>)}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Cookware Subcategory<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Cookware Subcategory" 
                                maxLength={100}
                                value={subDeptName}
                                onChange={(e) => {
                                    const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                    setSubDeptName(formatName(onlyAlphabets));
                                }}
                            />
                            {errors.name && (<div className="text-danger">{errors.name}</div>)}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Description" 
                                maxLength={250}
                                value={description}
                                onChange={(e) => setDescription(formatName(e.target.value))}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Cookware Subcategory <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddCookwareSubcategory;
